import React from 'react';
import connectToI18n from 'modules/i18n/connectToI18n';
import PropTypes from 'prop-types';
import { Button, Heading, Paragraph, Text } from 'components/ui';
import { connect } from 'react-redux';
import { actionTypes } from 'modules/giftCard';
import Backbone from 'backbone';

export class BuyGiftCardSuccess extends React.Component {
    static propTypes = {
        dispatch: PropTypes.func.isRequired,
        trans: PropTypes.func.isRequired,
        homeLink: PropTypes.string.isRequired,
    };

    onReturnClick = () => {
        this.props.dispatch({
            type: actionTypes.RESET,
        });
        Backbone.history.navigate(this.props.homeLink, { trigger: true });
    };

    render() {
        const { trans } = this.props;

        return (
            <div className="buyGiftCardMainContent">
                <Heading size={2} className="u-mb-4" responsive>
                    <Text color="success" size="ignore">
                        {trans('buyGiftCard.success.title')}
                    </Text>
                </Heading>
                <Paragraph className="u-mb-2">{trans('buyGiftCard.success.sub')}</Paragraph>
                <Paragraph className="u-mb-8">{trans('buyGiftCard.success.seeyousoon')}</Paragraph>
                <Button onClick={this.onReturnClick} block variant="success">
                    {trans('buyGiftCard.success.action')}
                </Button>
            </div>
        );
    }
}

export default connect()(connectToI18n(BuyGiftCardSuccess));
